$(document).ready(function () {
    $('.footer-uspbar').css('opacity', 1);
});
